import { MessageCircle, Send } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const WHATSAPP_URL =
  "https://wa.me/420725706235?text=Dobr%C3%BD%20den%2C%20m%C3%A1m%20z%C3%A1jem%20o%20pron%C3%A1jem%20vozidla.";

// Mobile-only sticky bottom action bar: inquiry + WhatsApp.
export const StickyMobileCTA = () => {
  const { t } = useLang();
  return (
    <div
      className="sm:hidden fixed bottom-0 left-0 right-0 z-50 flex gap-2 p-3 bg-[#0a0a0a]/95 backdrop-blur-md border-t border-white/10"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
      data-testid="sticky-mobile-cta"
    >
      <a
        href="#contact"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-orange-400 text-black text-sm font-semibold py-3 active:scale-95 transition-transform"
        data-testid="sticky-cta-inquiry"
      >
        <Send className="w-4 h-4" /> {t("sticky.inquiry")}
      </a>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-white text-sm font-semibold px-5 py-3 active:scale-95 transition-transform"
        data-testid="sticky-cta-whatsapp"
      >
        <MessageCircle className="w-4 h-4" /> WhatsApp
      </a>
    </div>
  );
};

export default StickyMobileCTA;
